import { useEffect } from "react";
import { GridItem } from "./grid";
import { GridTileImage } from "./tile";
import Label from "./label";
import { useSelector, useDispatch } from "react-redux";
import UserProductRatingsContainer from "components/source/user_product_ratings/user-product-ratings-container";
import { analytics } from "rtr-constants";
import ProductRatingsActions from "actions/product-ratings-actions";
import MidGridRender from "./mid-grid";
import { setGridProductDrawer } from "../../../slices/gridProductDrawer-slice";
import { useShowGridProductDrawer } from "helpers/grid-product-drawer-helper";
import { getUserId } from "../hoc/with-user-data";

export function ProductGridItems(_props) {
  const dispatch = useDispatch();
  const products = useSelector(state => state.gridProducts);
  const shouldShowDrawer = useShowGridProductDrawer();
  const userId = getUserId(useSelector(state => state.userData) || {});

  useEffect(() => {
    if (!userId) {
      return;
    }
    dispatch(ProductRatingsActions.loadUserProductRatings());
  }, [userId]);

  function formatLinkUrl(url) {
    return new URL(url).pathname;
  }

  const handleButtonClick = async (event, product) => {
    //Open the product drawer if enabled
    //If the user is doing Command+Click, use default behavior as user intends (open PDP in new tab)
    if (shouldShowDrawer && !event.metaKey) {
      event.preventDefault();
      dispatch(setGridProductDrawer({ productId: product.productId, pdpUrl: formatLinkUrl(product.pdpUrl) }));
    }
  };

  return (
    <MidGridRender>
      {products.map((product, index) => (
        <GridItem key={product.productId} className="animate-fadeIn">
          <UserProductRatingsContainer
            location={analytics.ACTION_LOCATIONS.GRID}
            product={product}
            productIndex={index}>
            <a
              className="relative inline-block h-full w-full"
              href={formatLinkUrl(product.pdpUrl)}
              onClick={event => handleButtonClick(event, product)}>
              <GridTileImage
                fill
                sizes="(min-width: 768px) 33vw, (min-width: 640px) 50vw, 100vw"
                product={product}
                isFirstProduct={index === 0}
              />
            </a>
          </UserProductRatingsContainer>
          <Label product={product} />
        </GridItem>
      ))}
    </MidGridRender>
  );
}
